import React from 'react';

// Formatting Toolbar Component
export function FormattingToolbar({ onFormat }) {
    return (
      <div className="formatting-toolbar flex items-center gap-2 mb-1">
        <button type="button" onClick={() => onFormat('b')} className="format-button px-3 py-1 text-sm font-bold border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-200 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800">B</button>
        <button type="button" onClick={() => onFormat('i')} className="format-button px-3 py-1 text-sm italic border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-200 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800">I</button>
        <button type="button" onClick={() => onFormat('u')} className="format-button px-3 py-1 text-sm underline border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-200 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800">U</button>
      </div>
    );
}
